// ── 공용 레벨 / 매너 뱃지 컴포넌트 ──────────────────────────────────────────

/**
 * LevelBadge — match_level (0~10, 전적 기반) 숫자를 "LV.{n}" 형태로 표시
 * match_level이 0이거나 null이면 "LV.0" 표시
 * compact=true: 팀 찾기 카드처럼 여러 배지를 가로 나열할 때 사용
 */
export function LevelBadge({ level, compact }) {
  const lv = (level != null && Number(level) > 0) ? Number(level) : 0;

  let bg;
  if (lv <= 0)      bg = "#9E9E9E";
  else if (lv <= 2) bg = "#4CAF50";
  else if (lv <= 4) bg = "#2196F3";
  else if (lv <= 6) bg = "#9C27B0";
  else if (lv <= 8) bg = "#FF9800";
  else              bg = "linear-gradient(135deg, #FF5722 0%, #FFC107 100%)";

  return (
    <div style={{ display: "inline-flex", alignItems: "center", borderRadius: 12, overflow: "hidden", border: "1px solid rgba(0,0,0,0.12)", flexShrink: 0, background: bg, padding: compact ? "3px 8px" : "5px 12px", gap: compact ? 1 : 2 }}>
      <span style={{ fontSize: compact ? 9 : 11, fontWeight: 800, color: "rgba(255,255,255,0.85)", letterSpacing: 0.3 }}>LV.</span>
      <span style={{ fontSize: compact ? 12 : 16, fontWeight: 900, color: "#fff", lineHeight: 1 }}>{lv}</span>
    </div>
  );
}

/**
 * SportLevelBadge — 종목별 구력 레벨(level 텍스트)을 표시
 * label prop이 있으면 "label value" 형태로 표시 (팀 찾기 카드: label="자체평가")
 * level이 없으면 렌더링하지 않음
 */
export function SportLevelBadge({ level, label }) {
  if (!level) return null;
  const displayText = label ? `${label} ${level}` : level;
  return (
    <div style={{ display: "inline-flex", alignItems: "center", borderRadius: 12, overflow: "hidden", border: "1px solid rgba(0,0,0,0.12)", flexShrink: 0, background: "#f0f0f0", padding: "3px 9px" }}>
      <span style={{ fontSize: 11, fontWeight: 700, color: "#555", lineHeight: 1, whiteSpace: "nowrap" }}>{displayText}</span>
    </div>
  );
}

/**
 * MannerBadge — manner_avg 점수를 크고 굵게 표시
 * [ 점수 | 매너 ] 형태, 점수별 색상 자동 적용
 * null/0이면 "0.0" + 회색으로 표시
 * compact=true: 팀 찾기 카드처럼 여러 배지를 가로 나열할 때 사용
 */
export function MannerBadge({ score, compact }) {
  const numScore = (score != null && !Number.isNaN(Number(score))) ? Number(score) : null;
  const hasScore = numScore != null && numScore > 0;
  const displayScore = hasScore ? numScore.toFixed(1) : "0.0";

  let bg;
  if (!hasScore)            bg = "#9E9E9E";
  else if (numScore >= 4.5) bg = "#FFC107";
  else if (numScore >= 3.5) bg = "#4CAF50";
  else if (numScore >= 2.5) bg = "#2196F3";
  else                      bg = "#F44336";

  return (
    <div style={{ display: "inline-flex", alignItems: "stretch", borderRadius: 12, overflow: "hidden", border: "1px solid rgba(0,0,0,0.12)", flexShrink: 0 }}>
      <div style={{ background: bg, padding: compact ? "3px 8px" : "6px 10px", display: "flex", alignItems: "center", justifyContent: "center", minWidth: compact ? 32 : 42 }}>
        <span style={{ fontSize: compact ? 13 : 16, fontWeight: 900, color: "#fff", lineHeight: 1 }}>
          {displayScore}
        </span>
      </div>
      <div style={{ background: "#ebebeb", padding: compact ? "3px 7px" : "6px 9px", display: "flex", alignItems: "center", fontSize: compact ? 9 : 11, fontWeight: 800, color: "#444", letterSpacing: 0.3 }}>
        매너
      </div>
    </div>
  );
}
